package com.macrofocus.eflux.network.physical

import com.macrofocus.common.units.*
import com.macrofocus.eflux.data.BranchPowerFlowRecord
import org.molap.network.UndirectedLink
import kotlin.math.absoluteValue
import kotlin.math.cos
import kotlin.math.sin
import kotlin.math.sqrt

typealias BranchId = String

fun branchIdOf(name: String) : BranchId = name

class Branch(override val from: Bus,
             override val to: Bus,
             val record: BranchPowerFlowRecord,
             val fullName: String = from.id + "-" + to.id + "-" + record.ckt
) : UndirectedLink<Bus, Bus>(from, to) {
    val id = branchIdOf(from.id + "-" + to.id + "-" + record.ckt)

    val longName: String = if(fullName.endsWith(")") && fullName.contains("(")) {
        fullName.substringBeforeLast("(")
    } else {
        fullName
    }

    val ckt = record.ckt

    val sbase = 100.0

    val met = record.met
    val met_k = if(met <= 1) to else from
    val met_m = if(met <= 1) from else to

    val zone_k = from.zone
    val zone_m = to.zone
    val crossBorder = zone_k != zone_m

    val v_k = from.v
    val v_m = to.v

    val va_k = from.record.va
    val va_m = to.record.va

    val va = (va_k + va_m) / 2
    val dva = va_k - va_m

    val vm_k = from.record.vm
    val vm_m = to.record.vm

    val vm = (vm_k + vm_m) / 2
    val dvm = vm_k - vm_m

    val r = record.r
    val x = record.x

    val dp = if(record.st >= 1) (((vm_k * vm_m * sin(dva.into(PhaseAngle.Radian).amount)) / x.amount) * sbase).amount.into(Power.Megawatt) else 0.Megawatt
    val p = dp.amount.absoluteValue.into(Power.Megawatt)
    val q = ((((vm_k * vm_k) - vm_k * vm_m * cos(dva.into(PhaseAngle.Radian).amount)) / x.amount) * sbase).amount.absoluteValue.into(ReactivePower.MegavoltAmpereReactive)
    val abs_s = sqrt(((p.amount * p.amount) + (q.amount * q.amount))).into(ApparentPower.MegavoltAmpere)

    val ratea = record.ratea
    val rateb = record.rateb
    val ratec = record.ratec

    val pratea = p.amount / ratea.amount
    val onepratea = 1.0 - (p.amount / ratea.amount)
    val sratea = abs_s.amount / ratea.amount

    val qratea = q.amount / ratea.amount

    val baskv = met_k.record.baskv

    override fun toString(): String = id
}